import React, { useState } from 'react'
import { SearchIcon } from '../../../Utils/svgUrlConstant'
import { useForm } from 'react-hook-form';
import { getDateAfterDays, getTodayDate } from '../carRental/CarRentalBanner';
import hotelrentbg from '../../../assets/images/hotel-hero-bg.png'

export default function HotelBanner() {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            city: "",
            checkInDate: getTodayDate(),
            dropOffDate: getDateAfterDays(3),
            guests: "1 Day",
        },
    });

    const onSubmit = (data) => {
        console.log("Hotel Search Data:", data);
    };
    const [pageLoading, setPageLoading] = useState(true);

    // if (pageLoading) {
    //     return <DataLoader />;  // Full screen loader
    // }

    return (
        <section className="section-equal-padding hotel_banner_sec  uk-scrollspy-inview position-relative"
            style={{
                backgroundImage: `url(${hotelrentbg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container">
                <div className="slider-content text-center mx-auto">
                    <h1>Hotel</h1>

                </div>
                <form className="search-wrapper bg-white" onSubmit={handleSubmit(onSubmit)}>
                    <div className="search-item">
                        <label className="form-label">City or hotel name</label>
                        <div className="input-group custom-input flex align-items-center gap-3">
                            <span><svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.75 20.75V14.18M8.75 9.75H9.75M8.75 5.75H9.75M10.75 14.18V20.75M11.75 14.75C10.8845 14.1009 9.83185 13.75 8.75 13.75C7.66815 13.75 6.61548 14.1009 5.75 14.75M13.75 9.75H12.76M13.75 5.75H12.76M4.75 9.75H4.76H5.75M4.75 5.75H5.75M2.75 0.75H14.75C15.8546 0.75 16.75 1.64543 16.75 2.75V18.75C16.75 19.8546 15.8546 20.75 14.75 20.75H2.75C1.64543 20.75 0.75 19.8546 0.75 18.75V2.75C0.75 1.64543 1.64543 0.75 2.75 0.75Z" stroke="#1A1E18" strokeWidth="1.5" />
                            </svg></span>
                            <input type="text" className="shadow-none outline-0 border-0 form-control p-0"
                                placeholder="City or hotel name" {...register("city", { required: "City / Hotel name is required" })} />
                        </div>
                        {errors.city && <p className="text-danger small">{errors.city.message}</p>}
                    </div>
                    <div className="search-item check_in">
                        <label className="form-label">Check-In</label>
                        <input type="date" className="form-control"  {...register("checkIn", { required: "Check-in date is required" })} />
                        {errors.checkIn && <p className="text-danger small">{errors.checkIn.message}</p>}
                    </div>
                    <div className="search-item check_in">
                        <label className="form-label">Check-Out</label>
                        <input type="date" className="form-control" {...register("checkOut", { required: "Check-out date is required" })} />
                        {errors.checkOut && <p className="text-danger small">{errors.checkOut.message}</p>}
                    </div>
                    <div className="search-item">
                        <label className="form-label">Guests</label>
                        <div className="input-group custom-input flex align-items-center gap-3">
                            <input
                                type="number"
                                className="shadow-none outline-0 border-0 form-control p-0"
                                placeholder="Number of days"
                                min={1}
                                {...register("guests", {
                                    required: "Number of days is required",
                                    min: {
                                        value: 1,
                                        message: "Minimum 1 day required",
                                    },
                                })}
                            />
                        </div>
                    </div>
                    <div className="search-item">
                        <button className="view-all-btn search_btn_hotel" type="submit">
                            <SearchIcon />
                            Search
                        </button>
                    </div>
                </form>
            </div>
        </section>
    )
}
